










































import {Vue, Component, Prop} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {Admin} from '@/types';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import RadioElement from '@/components/common/RadioElement.vue';
import {LEFT_MENU_FLG, I18N_LOCALE} from '@/const/words/cookie';
import cookies from 'js-cookie';

const adminModule = namespace('admin');

@Component({
  components: {CompSelectBox, RadioElement}
})
export default class ProfileSetting extends Vue {
  @adminModule.Getter('admin') private admin!: Admin;

  @Prop() private showFlg!: boolean;
  private closePop() {
    this.$emit('update:showFlg', false);
  }

  private initOver = false;

  // 사용언어 설정
  private language: string = 'KOREAN';
  private languages = [
    {
      value: 'KOREAN',
      name: 'PROFILE_SETTING_LANGUAGE_KOREAN'
    },
    {
      value: 'CHINESE',
      name: 'PROFILE_SETTING_LANGUAGE_CHINESE'
    },
    {
      value: 'JAPANESE',
      name: 'PROFILE_SETTING_LANGUAGE_JAPANESE'
    },
    {
      value: 'ENGLISH',
      name: 'PROFILE_SETTING_LANGUAGE_ENGLISH'
    }
  ];

  // 사용 시간대 설정
  private timeZone: string = 'ASIA_SEOUL';
  private timeZones = [
    {
      value: 'ASIA_SEOUL',
      name: 'PROFILE_SETTING_ASIA_SEOUL'
    },
    {
      value: 'GMT_Z',
      name: 'PROFILE_SETTING_GMT_Z'
    },
    {
      value: 'AMERICA_EASTERN',
      name: 'PROFILE_SETTING_AMERICA_EASTERN'
    },
    {
      value: 'AMERICA_CENTRAL',
      name: 'PROFILE_SETTING_AMERICA_CENTRAL'
    },
    {
      value: 'AMERICA_MOUNTAIN',
      name: 'PROFILE_SETTING_AMERICA_MOUNTAIN'
    },
    {
      value: 'AMERICA_PACIFIC',
      name: 'PROFILE_SETTING_AMERICA_PACIFIC'
    }
  ];

  // 좌측 메뉴 열림 설정
  private leftSideMenuOption: string = 'close';
  private leftMenuStatus = {
    name: 'leftMenuStatus',
    data: [
      {
        id: 'leftMenuStatus_oprn',
        value: 'open',
        dispaly: 'PROFILE_SETTING_OPEN'
      },
      {
        id: 'leftMenuStatus_close',
        value: 'close',
        dispaly: 'PROFILE_SETTING_CLOSE'
      }
    ]
  };

  private async save() {
    let request = {
      data: {
        language: this.language,
        timeZone: this.timeZone
      }
    };
    await this.$api.putAdminsServiceMe(request);
    cookies.set(LEFT_MENU_FLG, this.leftSideMenuOption, {expires: 30});
    //pro admin과 동일하게 변경 ( 만료 30일 )
    let i18nLocale = '';
    switch (this.language) {
      case 'CHINESE':
        i18nLocale = 'zh';
        break;
      case 'JAPANESE':
        i18nLocale = 'jp';
        break;
      case 'ENGLISH':
        i18nLocale = 'en';
        break;
      default:
        i18nLocale = 'kr';
        break;
    }
    cookies.set(I18N_LOCALE, i18nLocale);
    alert(window.$t('PROFILE_SETTING_SUCCESSFULLY_SAVED'));
    this.$router.go(0);
  }

  private async mounted() {
    $('body').addClass('no-scroll');
    let request: any = {
      params: {
        searchType: 'ADMIN_ID',
        keyword: this.admin.id
      }
    };

    let {data} = await this.$api.getAdminsService(request);
    let myAdmin = data.contents.find((tempAdmin) => tempAdmin.adminId === this.admin.id);
    if (myAdmin) {
      this.language = myAdmin.language;
      this.timeZone = myAdmin.timeZone;
    }

    const lmenuOpen = cookies.get(LEFT_MENU_FLG);
    if (lmenuOpen) {
      this.leftSideMenuOption = lmenuOpen;
    }
    this.initOver = true;
  }
  beforeDestroy() {
    $('body').removeClass('no-scroll');
  }
}
